module.exports = __webpack_public_path__ + "static/cesi_pagano_hero-9abeb191cb601de8c6dd7584be43bdb2.jpeg";